import { Select } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import {
  ExportConfigurationDto,
  GetExportConfigurationsResponseDto,
} from "~/gen/api"

type Props = {
  selectedExportConfiguration: ExportConfigurationDto | undefined
  setSelectedExportConfiguration: React.Dispatch<
    React.SetStateAction<ExportConfigurationDto | undefined>
  >
  exportConfigurationsData?: GetExportConfigurationsResponseDto
}

export const ExportConfigurationsSelect: React.FC<Props> = ({
  selectedExportConfiguration,
  exportConfigurationsData,
  setSelectedExportConfiguration,
}: Props) => {
  // Just for optimization
  const { t } = useTranslation("dataTransfer")

  const exportConfigurations = useMemo(() => {
    return exportConfigurationsData?.exportConfigurations || []
  }, [exportConfigurationsData?.exportConfigurations])

  const selectData = useMemo(() => {
    return exportConfigurations.map(
      (exportConfiguration: ExportConfigurationDto) => ({
        label: exportConfiguration.name,
        value: exportConfiguration.id.toString(),
      })
    )
  }, [exportConfigurations])

  const onSelectExportConfiguration = (value: string | null) => {
    if (!value || value === selectedExportConfiguration?.id?.toString()) return

    const foundConfig = exportConfigurations.find(
      (exportConfiguration) => exportConfiguration.id.toString() === value
    )

    if (foundConfig !== selectedExportConfiguration) {
      setSelectedExportConfiguration(foundConfig)
    }
  }

  return (
    <Select
      data={selectData}
      placeholder={t("export.placeholder")}
      value={selectedExportConfiguration?.id.toString()}
      onChange={onSelectExportConfiguration}
      clearable
    />
  )
}
